import React from "react";
import { Box, Button, Card, CardContent, Typography } from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";

const OrganizationNotReadyCard = () => {
  const handleRefresh = () => {
    window.location.reload();
  };

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      height="100vh"
      bgcolor="#f5f5f5"
    >
      <Card
        sx={{
          maxWidth: 400,
          textAlign: "center",
          p: 3,
          boxShadow: 3,
          borderRadius: 4,
        }}
      >
        <CardContent>
          <Typography variant="h5" gutterBottom>
            Organization Not Initialized
          </Typography>
          <Typography variant="body1" color="text.secondary" mb={3}>
            The organization is not set up yet. Please refresh the page later.
          </Typography>
          <Button
            variant="contained"
            startIcon={<RefreshIcon/>}
            onClick={handleRefresh}
          >
            Refresh
          </Button>
        </CardContent>
      </Card>
    </Box>
  );
};

export default OrganizationNotReadyCard;
